import { useEffect } from "react";

const PythonOutput = ({
  output,
  isRunning,
  isHorizontal,
  terminalRef,
  pendingInputPrompt,
  submitInput,
  inputValue,
  setInputValue,
}) => {
  useEffect(() => {
    if (terminalRef.current) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [output]);

  return (
    <div
      className={`w-full ${isHorizontal ? "h-[67vh] lg:w-1/2" : ""} relative rounded-lg bg-white shadow-md dark:bg-[#1e272e]`}
    >
      {/* Progress bar */}
      {isRunning && (
        <div className="progress">
          <div className="progress-bar progress-bar-info progress-bar-striped active w-full"></div>
        </div>
      )}

      <div
        id="terminal"
        ref={terminalRef}
        className={`${isHorizontal ? "h-[60vh]" : "h-[30vh]"} relative w-full overflow-auto rounded-lg bg-white p-4 dark:bg-[#1e272e] ${
          isRunning ? "text-gray-500" : "text-black dark:text-white"
        }`}
      >
        {/* Output text */}
        {output ? <pre className="whitespace-pre-wrap">{output}</pre> : null}

        {/* Input prompt appended inside terminal */}
        {(pendingInputPrompt || pendingInputPrompt == "") && (
          <>
            <div style={{ color: "#444", userSelect: "none" }}>{pendingInputPrompt}</div>
            <input
              autoFocus
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  submitInput();
                }
              }}
              style={{
                marginTop: 6,
                padding: "4px 8px",
                fontSize: 14,
                borderRadius: 4,
                border: "1px solid #ccc",
                flexGrow: 1,
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default PythonOutput;
